<template>
    <v-col cols="12" class="CreateReport mt-0 pt-0">
        <v-row
                align="stretch"
                justify="space-around"
                class="pa-4 pt-0"
                style="height: 100%"
        >
            <v-col cols="12" >
                <v-card
                        class="pa-4 elevation-0"
                        tile
                        height="100%"
                >
 <v-row >
                        <v-col>
                             <h2 class="font-weight-medium text-center title-reports my-6">
                                <strong>
                                    Carga de
                                </strong>  
                                cards Reportería</h2>
                        </v-col>
                        <v-btn
                                    
                                    dark
                                    fab
                                    x-small
                                    class="mx-2"
                                    color="#7F03BB"
                                    to="/system/reports/payment"
                            >
                                <v-icon>mdi-cart</v-icon>
                        </v-btn>  
                        <v-btn
                                    
                                    dark
                                    fab
                                    x-small
                                    class="mx-2"
                                    color="#FFB12A"
                                    @click="dialog.video = true"
                            >
                                <v-icon>mdi-play</v-icon>
                        </v-btn>  
                        <v-btn
                                    
                                    dark
                                    fab
                                    x-small
                                    class="mx-2"
                                    color="#0172C0"
                            >
                                <v-icon>mdi-flash</v-icon>
                        </v-btn>  
                    </v-row>
                    <v-card class="elevation-0">
                        <v-row>
                            <v-col md="12" xl="7">
                                <h4 class="subtitle-3">
                                    Ingreso de datos
                                </h4>
                                <v-card class="elevation-0 border-1 pa-3 mt-3">
                                    <v-row class="border-bottom-1">
                                        <v-col cols="12" xl="4">
                                            <v-text-field
                                                placeholder="Titulo *"
                                                dense
                                            ></v-text-field>

                                            <v-text-field
                                                placeholder="Fecha de creación *"
                                                dense
                                            ></v-text-field>

                                            <v-select
                                                :items="['Construccion','Mineria']" 
                                                placeholder="Selecciona rubros *"
                                                dense
                                            ></v-select>
                                            <v-select
                                                    :items="['5UF','10UF']" 
                                                    placeholder="Precios *"     
                                                    dense
                                            ></v-select>
                                            <v-select
                                                    :items="['Desarrollador 1']"
                                                    placeholder="Selecciona desarrollador *"
                                                    dense
                                            ></v-select>
                                            <v-select
                                                    :items="['Carro 1']"
                                                    placeholder="Carros (Opcional)"
                                                    dense
                                            ></v-select>
                                        </v-col>
                                        <v-col cols="12" xl="5">
                                            <v-textarea
                                                    name="input-7-1"
                                                    label="Descripción corta *"
                                                    value="Lorem Ipsum is simply dummy text of the printing and typesetting industry. "
                                            ></v-textarea>

                                            <v-textarea
                                                    name="input-7-1"
                                                    label="Descripción larga *"
                                                    value="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
                                            ></v-textarea>
                                        </v-col>
                                        <v-col cols="12" xl="3">
                                            <v-btn color="#7F03BB"
                                            small
                                            raised
                                            outlined
                                            class="pa-6 px-12" style="width:100%">Adjuntar imagen <br>portada</v-btn>

                                            <v-btn color="#7F03BB"
                                            small
                                            raised
                                            outlined
                                            class="mt-3 pa-6 px-12" style="width:100%">Adjuntar imagen <br>contenido </v-btn>
                                            <p class="mt-3">Destacados</p>
                                            <div class="d-flex">
                                                <v-checkbox
                                                    label="Si"
                                                    value="Si"
                                                ></v-checkbox>
                                                <v-checkbox
                                                    class="ml-5"
                                                    label="No"
                                                    value="No"
                                                ></v-checkbox>
                                            </div>
                                            
                                        </v-col>         
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <div class="d-flex">
                                                <v-checkbox
                                                    label="Habilitar"
                                                    value="Habilitar"
                                                ></v-checkbox>
                                                <v-checkbox
                                                    class="ml-5"
                                                    label="Deshabilitar"
                                                    value="Deshabilitar"
                                                ></v-checkbox>
                                                <v-checkbox
                                                    class="ml-5"
                                                    label="En desarrollo"
                                                    value="En desarrollo"
                                                ></v-checkbox>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-btn color="#7F03BB"
                                                raised
                                                dark
                                                class=" pa-6 px-12" >guardar</v-btn>
                                                <v-btn color="#7F03BB"
                                                raised
                                                outlined
                                                class="ml-3 pa-6 px-12" >cancelar</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-col>
                            <v-col md="12" xl="5">
                                <h4 class="subtitle-3">
                                    Previsualización
                                </h4>
                                <v-card class="pa-8 elevation-0 card-detail border-big"
                                    tile
                                    :style="{ backgroundImage: 'url(' + require('@/assets/images/reports/hero/hero-reports-3.jpg') + ')' }"
                                >
                                    <v-card-title class="headline pt-0 mx-auto justify-center">

                                        <v-row >
                                            <v-col cols="12" lg="7">
                                                <h1 class="font-weight-regular text-left font-family-1 font-size-30 mt-10 mb-4">
                                                Análisis de Desempeño de Plantas
                                                </h1>
                                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.
                                                </p>
                                            </v-col>
                                            <v-col cols="12" lg="5">
                                                
                                                <v-card class="elevation-0 card-value-dialog"
                                                >
                                                    <v-card-title>
                                                        <h5><span class="big">25 uf</span> Incluye 1 informe</h5>
                                                    </v-card-title>
                                                    <v-card-text>
                                                        <p>
                                                        <v-icon color="#FFF">mdi-check</v-icon>
                                                            Plan 5 informes</p>
                                                        <p>
                                                        <v-icon color="#FFF">mdi-check</v-icon>
                                                            Plan 10 informes</p>
                                                        <p>
                                                        <v-icon color="#FFF">mdi-check</v-icon>
                                                            Plan Acceso Ilimitado</p>
                                                        <a class="ma-auto">Ver más información</a>
                                                    </v-card-text>
                                                </v-card>

                                                <v-btn
                                                class="btn-report-3 mt-3 mb-10"
                                                to="/system/reports/payment"
                                                    >
                                                    Agregar al carro
                                                </v-btn>
                                            </v-col>
                                            
                                        </v-row>
                                    </v-card-title>
                                    <v-card-text >
                                        <v-row>
                                            <v-col cols="12" lg="6">
                                                <p>
                                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. 
                                                </p>
                                                <p>
                                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the.
                                                </p>
                                            </v-col>
                                            <v-col cols="12" lg="6">
                                                <h4 >Informe ideal para</h4>
                                                <v-card class="pa-5 d-flex justify-space-around">
                                                    <img
                                                            src="@/assets/images/reports/ico/educacional.png"
                                                            alt="educacional"
                                                    >

                                                    <img
                                                        src="@/assets/images/reports/ico/supermercado.png"
                                                        alt="supermercado"
                                                >

                                                    <img
                                                        src="@/assets/images/reports/ico/edificios.png"
                                                        alt="edificios"
                                                >

                                                    <img
                                                        src="@/assets/images/reports/ico/mineria.png"
                                                        alt="mineria"
                                                >
                                                </v-card>

                                                <v-carousel height="200px" hide-delimiters>
                                                            <v-carousel-item
                                                            v-for="(item,i) in 5"
                                                            :key="i"
                                                            >
                                                                <v-row>
                                                                    <v-col>
                                                                        <v-card color="#f9f9f9" class="elevation-1 rounded-lg pa-3" height="190px">
                                                                            <h3 class="grey--text">Grafico {{1+(i)}}</h3>
                                                                        </v-card>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-carousel-item>
                                                        </v-carousel>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                                
                            </v-col>
                        </v-row>
                    
                    </v-card>
                </v-card>
            </v-col>
        </v-row>
    </v-col>
</template>
<style lang="scss">
.CreateReport{
    .v-label{
        font-size: 16px;
    }
}
</style>
<script>
    export default {
        name: 'CreateReport',
        created: function () {
            this.$emit('SetcolorMenu', '#7F03BB');
        }
    }
</script>